<template>
  <ul class="menu-nav">
    <template v-for="(menu_item, i) in items">
      <template v-if="menu_item.section">
        <li class="menu-section" :key="i">
          <h4 class="menu-text">{{ menu_item.section }}</h4>
          <i class="menu-icon flaticon-more-v2"></i>
        </li>
      </template>
      <template v-else-if="menu_item.submenu">
        <li
          :key="i"
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          v-bind:class="{
            'menu-item-open': hasActiveChildren(menu_item.page)
          }"
        >
          <a href="#" class="menu-link menu-toggle">
            <i :class="menu_item.icon" class="menu-icon"></i>
            <span class="menu-text">{{ menu_item.title }}</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="menu-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <li aria-haspopup="true" class="menu-item menu-item-parent">
                <span class="menu-link">
                  <span class="menu-text">{{ menu_item.title }}</span>
                </span>
              </li>
              <KTMenu :items="menu_item.submenu"></KTMenu>
            </ul>
          </div>
        </li>
      </template>
      <template v-else>
        <router-link
          :key="i"
          :to="menu_item.page"
          v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[
              isActive && 'menu-item-active',
              isExactActive && 'menu-item-active'
            ]"
          >
            <a :href="href" class="menu-link" @click="navigate">
              <i class="menu-icon" :class="menu_item.icon"></i>
              <span class="menu-text">{{ menu_item.title }}</span>
            </a>
          </li>
        </router-link>
      </template>
    </template>
  </ul>
</template>

<script>
import KTMenu from "@/view/layout/aside/Menu.vue";
export default {
  name: "KTMenu",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  comments: {
    KTMenu
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
